export enum SubscriptionType {
    Surveillance = 1,
    MindCare = 101,
}
